import { MantineReactTable } from "mantine-react-table";
import { MRT_Localization_FA } from "mantine-react-table/locales/fa";
import { t } from "i18next";
import "./base-table.scss";

export default function BaseTable({ columns, rows, details, action, loading, rowBackground }) {
    return (
        <MantineReactTable
            columns={columns}
            data={rows}
            enableRowActions={action}
            enableColumnActions={false}
            enableFullScreenToggle={false}
            enableDensityToggle={false}
            enableHiding={false}
            enableFilters={false}
            enablePagination={false}
            layoutMode="grid"
            initialState={{
                // showGlobalFilter: true,
                density: "xs",
            }}
            defaultColumn={{
                minSize: 20,
                size: 120,
            }}
            state={{
                showSkeletons: loading,
            }}
            renderEmptyRowsFallback={() => <div style={{ textAlign: "center", padding: "2rem" }}>{t("Messages.No Items to Display")} </div>}
            mantineTableHeadCellProps={{
                align: "center",
                sx: {
                    padding: "1rem 0 !important",
                },
            }}
            mantineTableBodyCellProps={{
                align: "center",
                sx: {
                    background: `${rowBackground}`,
                },
            }}
            positionGlobalFilter="left"
            positionActionsColumn="last"
            localization={MRT_Localization_FA}
            renderDetailPanel={details ? ({ row }) => row?.original?.details : ""}
            renderRowActions={({ row }) => row.original.action}
        />
    );
}
